import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryGoodsReceiptAdjustmentReceiptDateEarlierThanAdjustedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.inventory.goods-receipt-adjustment.validation.receipt-date.earlier-than-adjusted');
    }
}
